import {Component} from '@angular/core';
import {filter, map, tap} from 'rxjs/operators';
import {AsaxBookmarkingService} from 'asax-bookmarking';

const defaultSkyViewWidth = 61.8;
const defaultSkyViewHeight = 50;
const fractionDigits = 2;

const skyViewWidthQueryParam = 'skyViewWidth';
const skyViewHeightQueryParam = 'skyViewHeight';

@Component({
  selector: 'asax-app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  readonly gutterSize = 10;
  readonly gutterDoubleClickDuration = 300;

  skyViewHeight = defaultSkyViewHeight;
  skyViewWidth = defaultSkyViewWidth;

  constructor(private readonly asaxBookmarkingService: AsaxBookmarkingService) {
    this.asaxBookmarkingService.getQueryParam(skyViewWidthQueryParam).pipe(
      map((skyViewWidth: string) => Number.parseFloat(skyViewWidth)),
      filter((skyViewWidth: number) => this.skyViewWidth !== skyViewWidth),
      tap((skyViewWidth: number) => this.skyViewWidth = skyViewWidth),
    ).subscribe();

    this.asaxBookmarkingService.getQueryParam(skyViewHeightQueryParam).pipe(
      map((skyViewHeight: string) => Number.parseFloat(skyViewHeight)),
      filter((skyViewHeight: number) => this.skyViewHeight !== skyViewHeight),
      tap((skyViewHeight: number) => this.skyViewHeight = skyViewHeight),
    ).subscribe();
  }

  dragEndSkyViewHeight({sizes}: any) {
    this.skyViewHeight = sizes[0]?.toFixed(fractionDigits);
    this.asaxBookmarkingService.addParamsToUrl({[skyViewHeightQueryParam]: this.skyViewHeight});
  }

  dragEndSkyViewWidth({sizes}: any) {
    this.skyViewWidth = sizes[0]?.toFixed(fractionDigits);
    this.asaxBookmarkingService.addParamsToUrl({[skyViewWidthQueryParam]: this.skyViewWidth});
  }

  resetSkyViewHeight() {
    this.skyViewHeight = defaultSkyViewHeight;
    this.asaxBookmarkingService.removeParamsFromUrl(skyViewHeightQueryParam);
  }

  resetSkyViewWidth() {
    this.skyViewWidth = defaultSkyViewWidth;
    this.asaxBookmarkingService.removeParamsFromUrl(skyViewWidthQueryParam);
  }
}
